// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"3481d3e9","232":"91fb8a5d","237":"61682ae7","357":"57a511d5","526":"60affda8","872":"91567f4a"}[chunkId] + ".chunk.js";
};